import {computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import MoneyRenderer from "../utils/MoneyRenderer";

export class CheckingAccountFeature {
    constructor(application, navigator) {
        this._application = application;
        this._navigator = navigator;
        this._loaded = false;
        this._accountAndDocuments = null;

        makeObservable(this, {
            _accountAndDocuments: observable,
            accountAndDocuments: computed,
            _loaded: observable

        })
    }

    async load() {
        await this._getAccountAndDocuments()
        this.finishLoading()
    }

    finishLoading() {
        this._loaded = true
    }

    get loaded() {
        return this._loaded;
    }

    set loaded(value) {
        this._loaded = value;
    }

    get accountAndDocuments() {
        return this._accountAndDocuments;
    }

    set accountAndDocuments(value) {
        this._accountAndDocuments = value;
    }

    get accountMovementsHistory() {
        return this._accountMovementsHistory;
    }

    set accountMovementsHistory(value) {
        this._accountMovementsHistory = value;
    }

    balance(accountingDocument) {
        return accountingDocument.total
    }

    expirationDate(accountingDocument){
        return accountingDocument.expirationDate
    }

    receiptNumber(accountingDocument){
        return accountingDocument.number
    }

    receiptName(accountingDocument){
        return accountingDocument.type
    }

    issueDate(accountingDocument) {
        return accountingDocument.emissionDate
    }

    accountCustomerName() {
        return this.currentAccount().fantasyName;
    }

    accountBusinessName() {
        return this.currentAccount().businessName;
    }

    accountingDocuments(){
        return this._accountAndDocuments.accountingDocuments
    }

    sortedAccountingDocuments() {
        return this.accountingDocuments().slice().sort((anAccountingDocument, anotherAccountingDocument) => {
            const dateA = this.parseDate(anAccountingDocument.emissionDate);
            const dateB = this.parseDate(anotherAccountingDocument.emissionDate);
            return dateB - dateA;
        });
    }

    parseDate(dateString) {
        const [day, month, year] = dateString.split("-").map(Number);
        return new Date(year, month - 1, day); // Meses en JS van de 0 (Enero) a 11 (Diciembre)
    }

    currentAccount() {
        return this._accountAndDocuments.currentAccount
    }

    toOverdueBalance() {
        return MoneyRenderer(this.currentAccount().outstandingBalanceAmount);
    }

    overdueBalance() {
        return MoneyRenderer(this.currentAccount().overdueBalanceAmount);
    }

    unassignedBalance() {
        return MoneyRenderer(this.currentAccount().unassignedBalanceAmount);
    }

    consolidatedBalance() {
        return MoneyRenderer(this.currentAccount().totalBalanceAmount);
    }

    _getAccountAndDocuments() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._accountAndDocuments = response.currentAccountAndDocuments();
            },
            handlesError: (response) => {
                console.log('No se pudieron obtener los pedidos')
            }
        });
        return this._application.apiClient().checkingAccount(responseHandler, this._application.getCustomer())
    }
}